module.exports = __webpack_public_path__ + "static/media/DPI-maintenance.dfd38cfa.png";